export const actionsFilters = [
  {
    value: JSON.stringify([
      { key: "event", value: "PAGE" },
      { key: "action", value: "VIEW" }
    ]), label: 'Vista de sección'
  },
  {
    value: JSON.stringify([
      { key: "event", value: "AIRFIND_USER" },
      { key: "action", value: "UPDATE" }
    ]), label: 'Edicion de usuario'
  },
  {
    value: JSON.stringify([
      { key: "event", value: "USER" },
      { key: "action", value: "UPDATE" }
    ]), label: 'Edicion de operador'
  },
  {
    value: JSON.stringify([
      { key: "event", value: "TICKET" },
      { key: "action", value: "UPDATE" }
    ]), label: 'Cierre de ticket'
  },
  {
    value: JSON.stringify([
      { key: "event", value: "AUTH_SUCCESS" },
      { key: "action", value: "LOG_IN" }
    ]), label: 'Acceso a la plataforma'
  },
]